// disabling eslint temporarily for legacy files until they can be refactored
/* eslint-disable */
import React from "react";
import clsx from "clsx";
import { Col, Row, Spinner } from "react-bootstrap";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory from "react-bootstrap-table2-filter";
import language from "../../utils/en.json";
import styles from "./basicTable.module.scss";

/**
 * A basic bootstrap table component with no filtering, sorting, or pagination
 * @param {Boolean} isLoading (Required) Whether or not the parent component is in a loading state
 * @param {Boolean} isError (Required) Whether or not there is an error in the parent component
 * @param {Array} tableData (Required) The data to display in the table, if not provided, the table will default to the error view
 * @param {Array} columns (Required) The column definition for the table
 * @param {String} keyField (Required) The unique column field of the table (bootstrap table required field)
 * @param {String} tableClass (Optional) Class to apply to the outermost component wrapper
 * @param {String} headerText (Optional) The header title text
 */
export function BasicTable(props) {
  const {
    isLoading,
    isError,
    tableData,
    columns,
    keyField,
    tableClass,
    headerText,
    bordered = false,
  } = props;

  return (
    <div id={tableClass}>
      {/* Table header */}
      {headerText !== undefined && (
        <Row>
          <Col>
            <p
              className={clsx(
                styles["table-header"],
                "font-bolder font-color-7 p-2"
              )}
            >
              {headerText}
            </p>
          </Col>
        </Row>
      )}

      {/* Table body */}
      <Row>
        <Col sm="12" md="12" lg="12" xl="12">
          {isError || !tableData || !tableData?.length ? (
            <div className="no-data-label mb-4 pb-2">
              {language["GENERAL.NO_DATA"]}
            </div>
          ) : isLoading ? (
            <Spinner />
          ) : (
            <ToolkitProvider
              keyField={keyField}
              data={tableData}
              columns={columns}
            >
              {(props) => (
                <Row>
                  <Col md="12">
                    <BootstrapTable
                      {...props.baseProps}
                      keyField={keyField}
                      loading={isLoading}
                      filter={filterFactory()}
                      bordered={bordered}
                      hover={!!(!isLoading && tableData?.length)}
                      bootstrap4
                    />
                  </Col>
                </Row>
              )}
            </ToolkitProvider>
          )}
        </Col>
      </Row>
    </div>
  );
}
